
define('ldsh!modules/page_listing/templates/search_tagcloud_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p +=
((__t = ( text )) == null ? '' : __t) +
'<i class="ed-icon ed-icon-cancel js-remove-tag"></i>\n';

}
return __p
};});

